/**
 * Zubehör und Community — dieselben Listen, die der David Media Installer zeigt.
 *
 * Bewusst als Datei und nicht aus dem Server: es sind feste Verweise, sie ändern
 * sich selten, und so lädt die Seite ohne zusätzlichen Aufruf. Wenn du hier etwas
 * änderst, gehört dieselbe Änderung in
 *   ~/Projects/GraphFlow-Installer/assets.json
 *   ~/Projects/GraphFlow-Installer/community.json
 * damit App und Website nicht auseinanderlaufen.
 */

export const ASSETS = [
  {
    id: 'text-animations',
    name: '5+ Text Animations',
    beschreibung: 'Fertige Textanimationen als AE-Projekt.',
    bild: '/products/titel/text-animations.jpg',
    preis: 'Gratis',
    url: 'https://www.davidmedia.de/products/text-animations.zip',
  },
  {
    id: 'text-animations-2',
    name: 'Text Animations Vol. 2',
    beschreibung: 'Zweite Sammlung, gleicher Aufbau.',
    bild: '/products/titel/text-animations-2.jpg',
    preis: 'Gratis',
    url: 'https://www.davidmedia.de/products/text-animations-2.zip',
  },
  {
    id: 'animated-gradients',
    name: 'Animated Gradients',
    beschreibung: 'Bewegte Verläufe als Footage.',
    bild: '/products/titel/animated-gradients.jpg',
    preis: 'Gratis',
    url: 'https://www.davidmedia.de/products/animated-gradients.zip',
  },
];

// `url: ''` heißt: gibt es noch nicht — die Kachel wird als „bald" gezeigt statt
// verlinkt. Sobald der Discord-Server steht, hier die Einladung eintragen.
// Behance und LinkedIn standen hier auch mal. Beides sind Kanaele fuer
// Auftraggeber, keine Orte, an denen sich Nutzer der Werkzeuge treffen —
// in einer Community-Liste weckten sie die falsche Erwartung.
export const COMMUNITY = [
  { id: 'instagram', name: 'Instagram', text: 'Ausschnitte aus laufenden Projekten.', url: 'https://www.instagram.com/started.david' },
  { id: 'tiktok',    name: 'TikTok',    text: 'Kurze Kniffe für After Effects.', url: 'https://www.tiktok.com/@started.david' },
  { id: 'discord',   name: 'Discord',   text: 'Austausch, Hilfe und Neues zuerst.', url: '' },
  { id: 'support',   name: 'Support',   text: 'Direkter Draht bei Problemen.', url: 'https://www.davidmedia.de/support' },
];
